import { Helmet } from 'react-helmet-async';

const BASE_URL = 'https://careerplatform.online';

function SEO({ title, description, path, type = 'website' }) {
    const fullTitle = title
        ? `${title} — Career Platform`
        : 'Career Platform';

    const url = path ? `${BASE_URL}${path}` : BASE_URL;
    const publicUrl = process.env.PUBLIC_URL || '';

    return (
        <Helmet>
            <title>{fullTitle}</title>
            <link rel="icon" href={`${publicUrl}/favicon.ico`} />
            <link rel="apple-touch-icon" href={`${publicUrl}/logo192.png`} />
            <link rel="manifest" href={`${publicUrl}/manifest.json`} />
            <meta name="description" content={description} />
            <link rel="canonical" href={url} />

            <meta property="og:type" content={type} />
            <meta property="og:title" content={fullTitle} />
            <meta property="og:description" content={description} />
            <meta property="og:url" content={url} />
            <meta property="og:image" content={`${BASE_URL}/logo512.png`} />

            <meta name="twitter:title" content={fullTitle} />
            <meta name="twitter:description" content={description} />
            <meta name="twitter:image" content={`${BASE_URL}/logo512.png`} />
        </Helmet>
    );
}

export default SEO;
